import { FieldMetadata, ViewMetadata } from "src/cer/cer-data/cer-data-types";
import { CerFormPaneType, uiCmdPaneBottomClose } from "@form/cer-form-panes/cer-form-panes.service";
import { CerFormViewSet } from '@form/cer-form-view-set';

import { CerFormView } from "@form/cer-form-view";
import { UiCommand, UiCommandEvent } from "@ui/cer-ui-types";

export const cmdCustInvoiceDocument: UiCommand = { id: 'cmdCustInvoiceDocument', text: 'Dokument', iconCss: 'document' };

export const TableViewMetadata: ViewMetadata = {
  name: 'salgs-fakturaer', dataApiName: 'CustInvoice', text: 'Fakturaer', textSingular: 'Faktura',
  primaryKey: 'num',  titleFields: ['num'], baseFields: ['id', 'num', 'name', 'history']
};

export const TableFieldMetadata: FieldMetadata[] = [
  { name: 'num', text: 'Nummer', allowEdit: false },
  { name: 'name', text: 'Navn' },
  { name: 'invoiceDate', text: 'Fakturadato', format: 'DateShort' },
  { name: 'invoiceNum', text: 'Fakturanr.' },
  { name: 'currency', text: 'Valuta' },
  { name: 'amountCurExTax', text: 'Eks. moms', format: 'Amount' },
  { name: 'amountCurTax', text: 'Moms', format: 'Amount' },
  { name: 'amountCur', text: 'Fakturabeløb', format: 'Amount' },
  { name: 'amountCurService', text: 'Tillæg', format: 'Amount' },
  { name: 'settleDate', text: 'Betalt dato', format: 'DateShort' },
  { name: 'formRecognizerDocument', text: 'Formular dokument', format: 'Integer', visible: false },
  { name: 'voucherMessage', text: 'Besked', format: 'Integer', visible: false },
  { name: 'voucher', text: 'Udgiftsbilag', format: 'Integer', visible: false },
  { name: 'voucherNum', text: 'Bilagnr.' },
  { name: 'status', text: 'Bogført', format: 'CheckBox', allowFiltering: false, allowSorting: false },
  { name: 'custNum', text: 'Debitor' },
  { name: 'custEAN', text: 'EAN' },
  { name: 'custVATNum', text: 'CVR' },
  { name: 'custEmail', text: 'E-mail', format: 'Email' },
  { name: 'custPhone', text: 'Telefon', format: 'Phone' },
  { name: 'paymentFeeMst', text: 'Betal gebyr', format: 'Amount' },
  { name: 'paymentType', text: 'Betaling' },
  { name: 'paymentReference', text: 'Betalingsref' },
  { name: 'salesOrder', text: 'Salgsordre' },
  { name: 'salesChannel', text: 'Salgskanal' },
  { name: 'companyName', text: 'Fakturanavn' },
  { name: 'address1', text: 'Adresse 1' },
  { name: 'address2', text: 'Adresse 1' },
  { name: 'postalCode', text: 'Postnr.' },
  { name: 'postalDistrict', text: 'By' },
  { name: 'countryCode', text: 'Land' },
  { name: 'note', text: 'Kundenotat', format: 'TextArea' },
  { name: 'createdJobId', text: 'Oprettet job', visible: false },
  { name: 'modifiedJobId', text: 'Rettet job', visible: false },
];

export const LineViewMetadata: ViewMetadata = {
  name: 'salgs-faktura-linjer', dataApiName: 'CustInvoiceLine', text: 'Fakturalinjer', textSingular: 'Fakturalinje',
  primaryKey: 'id', parentPrimaryKey: 'num', parentForeignKey: 'invoice',
  baseFields: ['id', 'history'], titleFields: ['id', 'name']
};

export const LineFieldMetadata: FieldMetadata[] = [
  { name: 'line', text: 'Linje', format: 'Integer', visible: false, orderBy: 'Ascending', orderByPriority: 1 },
  { name: 'invoice', text: 'Faktura', tooltipText: 'Fakturaens interne nr.', visible: false },
  { name: 'type', text: 'Type', foreignKeyTableName: 'SalesOrderLineType', foreignKeyField: 'id', foreignKeyValue: 'name', width: '80px', visible: false },
  { name: 'category', text: 'Kategori', visible: false },
  { name: 'salesOrderLine', text: 'Ordrelinje', visible: false },
  { name: 'product', text: 'ISBN' },
  { name: 'name', text: 'Navn' },
  { name: 'qty', text: 'Antal', format: 'Number', footerType: 'Sum' },
  { name: 'price', text: 'Pris', format: 'Amount', footerType: 'Sum', visible: false },
  { name: 'amountCurDiscount', text: 'Rabat', format: 'Amount', footerType: 'Sum', visible: false },
  { name: 'amountCurExTax', text: 'Eks moms', format: 'Amount', footerType: 'Sum', visible: false },
  { name: 'amountCurTax', text: 'Moms', format: 'Amount', footerType: 'Sum', visible: false },
  { name: 'amountCur', text: 'Beløb', format: 'Amount', footerType: 'Sum' }
];

export class CustInvoiceView {

  public static viewSetAsViews(viewSet: CerFormViewSet): CerFormView[] {
    return viewSet.paneViews.flatMap(pv => pv.view);
  }
   
   public static viewSetGet(
    parentView: CerFormView,
    parentKey: object, /* = { parentPrimaryKey: 'msgId', parentForeignKey: 'voucherMessage' }, */
    paneTable: CerFormPaneType = 'main', 
    paneLine: CerFormPaneType = 'bottom',
    filterOnlyDraft: boolean = null,
    onCommand: ((e: UiCommandEvent) => void) = null) : CerFormViewSet {

    const invoiceAllowEdit = filterOnlyDraft;
    const filterStatus : any = null; // invoiceAllowEdit === false ? false : null;
    const setup: CerFormViewSet = new CerFormViewSet();

    const view = new CerFormView();

    view.onCommandEvent = onCommand;

    view.paneTarget = paneTable;
    view.viewMetadata = Object.assign(parentKey, CustInvoiceView.tableView([], invoiceAllowEdit));
    view.fieldMetadata = CustInvoiceView.tableFields(filterStatus, true);
    view.toolbarCommands = [uiCmdPaneBottomClose].concat(CustInvoiceView.tableToolbar(filterStatus, false));
    setup.viewAdd(view, parentView);

    const viewLines = new CerFormView();

    viewLines.onCommandEvent = onCommand;
    viewLines.paneTarget = paneLine;
    viewLines.viewMetadata = CustInvoiceView.lineView(invoiceAllowEdit);
    viewLines.fieldMetadata = CustInvoiceView.lineFields(invoiceAllowEdit);
    viewLines.toolbarCommands = CustInvoiceView.lineToolbar(invoiceAllowEdit);
    setup.viewAdd(viewLines, view);
    
    return setup;
  }

  public static tableView(routeParams: string[], isDraft: boolean): ViewMetadata {
    var canEdit = isDraft !== false;
    return Object.assign(
      { dataApiParams: routeParams, allowCreate: canEdit, allowEdit: canEdit, allowDelete: canEdit },
      TableViewMetadata
    );
  }

  public static tableFields(isDraft: boolean = null,  simple: boolean = false): FieldMetadata[] {
    var fields: FieldMetadata[] = TableFieldMetadata.map(f => Object.assign({}, f));

    if (simple === true) {
      var simpleFieldNames: string[] = ['num', 'name', 'amountCur', 'amountCurService', 'paymentFeeMst', 'paymentReference'];
      fields.forEach(f => f.visible = simpleFieldNames.includes(f.name));
      fields.filter(f => f.name.startsWith("amount") || f.name == 'paymentFeeMst').forEach(f => f.footerType = 'Sum');
    }

    if (isDraft === true || isDraft === false) {
      fields.filter(f => f.name == 'status').forEach(f => {
        f.filterValue = (isDraft ? 0 : 1);
        f.filterOperator = 'equal';
      });
    }

    return fields;
  }

  public static tableToolbar(isDraft: boolean = null, isCredit: boolean = null): UiCommand[] {
    var toolbar: UiCommand[] = [];
    if (isCredit === false && isDraft === false) {
    //  toolbar.push(cmdCustInvoiceDocument);
    }
    return toolbar;
  }

  public static lineView(isDraft: boolean = null): ViewMetadata {
    return Object.assign(
      { allowCreate: isDraft === true, allowEdit: isDraft === true, allowDelete: isDraft === true },
      LineViewMetadata
    );
  }

  public static lineFields(isDraft: boolean = null): FieldMetadata[] {
    var fields: FieldMetadata[] = LineFieldMetadata.map(f => Object.assign({}, f));
    return fields;
  }

  public static lineToolbar(isDraft: boolean): UiCommand[] {
    var toolbar: UiCommand[] = [];
    return toolbar;
  }
}
